// Based on newsletter-popup.js

const REGION_COUNTRIES = {

  Africa: [
    'AC', // Ascension Island
    'AO', // Angola
    'BF', // Burkina Faso
    'BI', // Burundi
    'BJ', // Benin
    'BV', // Bouvet Island
    'BW', // Botswana
    'CD', // Congo - Kinshasa
    'CF', // Central African Republic
    'CG', // Congo - Brazzaville
    'CI', // Côte d’Ivoire
    'CM', // Cameroon
    'CV', // Cape Verde
    'DJ', // Djibouti
    'DZ', // Algeria
    'EG', // Egypt
    'EH', // Western Sahara
    'ER', // Eritrea
    'ET', // Ethiopia
    'GA', // Gabon
    'GH', // Ghana
    'GM', // Gambia
    'GN', // Guinea
    'GQ', // Equatorial Guinea
    'GW', // Guinea-Bissau
    'KE', // Kenya
    'KM', // Comoros
    'LR', // Liberia
    'LS', // Lesotho
    'LY', // Libya
    'MA', // Morocco
    'MG', // Madagascar
    'ML', // Mali
    'MR', // Mauritania
    'MU', // Mauritius
    'MW', // Malawi
    'MZ', // Mozambique
    'NA', // Namibia
    'NE', // Niger
    'NG', // Nigeria
    'RE', // Réunion
    'RW', // Rwanda
    'SC', // Seychelles
    'SD', // Sudan
    'SH', // Saint Helena
    'SL', // Sierra Leone
    'SN', // Senegal
    'SO', // Somalia
    'SS', // South Sudan
    'ST', // São Tomé & Príncipe
    'SZ', // Eswatini
    'TA', // Tristan da Cunha
    'TD', // Chad
    'TF', // French Southern Territories
    'TG', // Togo
    'TN', // Tunisia
    'TZ', // Tanzania
    'UG', // Uganda
    'YT', // Mayotte
    'ZA', // South Africa
    'ZM', // Zambia
    'ZW', // Zimbabwe
  ],

  Asia: [
    'AE', // United Arab Emirates
    'AF', // Afghanistan
    'AM', // Armenia
    'AZ', // Azerbaijan
    'BD', // Bangladesh
    'BH', // Bahrain
    'BN', // Brunei
    'BT', // Bhutan
    'CN', // China
    'CY', // Cyprus
    'GE', // Georgia
    'HK', // Hong Kong SAR
    'ID', // Indonesia
    'IL', // Israel
    'IN', // India
    'IO', // British Indian Ocean Territory
    'IQ', // Iraq
    'IR', // Iran
    'JO', // Jordan
    'JP', // Japan
    'KG', // Kyrgyzstan
    'KH', // Cambodia
    'KP', // North Korea
    'KR', // South Korea
    'KW', // Kuwait
    'KZ', // Kazakhstan
    'LA', // Laos
    'LB', // Lebanon
    'LK', // Sri Lanka
    'MM', // Myanmar
    'MN', // Mongolia
    'MO', // Macao SAR
    'MV', // Maldives
    'MY', // Malaysia
    'NP', // Nepal
    'OM', // Oman
    'PH', // Philippines
    'PK', // Pakistan
    'PS', // Palestine
    'QA', // Qatar
    'SA', // Saudi Arabia
    'SG', // Singapore
    'SY', // Syria
    'TH', // Thailand
    'TJ', // Tajikistan
    'TL', // Timor-Leste
    'TM', // Turkmenistan
    'TR', // Türkiye
    'TW', // Taiwan
    'UZ', // Uzbekistan
    'VN', // Vietnam
    'YE', // Yemen
  ],

  Europe: [
    'AD', // Andorra
    'AL', // Albania
    'AT', // Austria
    'AX', // Åland Islands
    'BA', // Bosnia & Herzegovina
    'BE', // Belgium
    'BG', // Bulgaria
    'BY', // Belarus
    'CH', // Switzerland
    'CZ', // Czechia
    'DE', // Germany
    'DK', // Denmark
    'EE', // Estonia
    'ES', // Spain
    'FI', // Finland
    'FO', // Faroe Islands
    'FR', // France
    'GB', // United Kingdom
    'GG', // Guernsey
    'GI', // Gibraltar
    'GR', // Greece
    'HR', // Croatia
    'HU', // Hungary
    'IE', // Ireland
    'IM', // Isle of Man
    'IS', // Iceland
    'IT', // Italy
    'JE', // Jersey
    'LI', // Liechtenstein
    'LT', // Lithuania
    'LU', // Luxembourg
    'LV', // Latvia
    'MC', // Monaco
    'MD', // Moldova
    'ME', // Montenegro
    'MK', // North Macedonia
    'MT', // Malta
    'NL', // Netherlands
    'NO', // Norway
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'RS', // Serbia
    'RU', // Russia
    'SE', // Sweden
    'SI', // Slovenia
    'SJ', // Svalbard & Jan Mayen
    'SK', // Slovakia
    'SM', // San Marino
    'UA', // Ukraine
    'VA', // Vatican City
    'XK', // Kosovo
  ],

  'North America': [
    'AG', // Antigua & Barbuda
    'AI', // Anguilla
    'AN', // Netherlands Antilles
    'AW', // Aruba
    'BB', // Barbados
    'BL', // Saint Barthélemy
    'BM', // Bermuda
    'BQ', // Caribbean Netherlands
    'BS', // Bahamas
    'BZ', // Belize
    'CA', // Canada
    'CR', // Costa Rica
    'CU', // Cuba
    'CW', // Curaçao
    'DM', // Dominica
    'DO', // Dominican Republic
    'GD', // Grenada
    'GL', // Greenland
    'GP', // Guadeloupe
    'GT', // Guatemala
    'HN', // Honduras
    'HT', // Haiti
    'JM', // Jamaica
    'KN', // Saint Kitts & Nevis
    'KY', // Cayman Islands
    'LC', // Saint Lucia
    'MF', // Saint Martin
    'MS', // Montserrat
    'MQ', // Martinique
    'MX', // Mexico
    'NI', // Nicaragua
    'PA', // Panama
    'PM', // Saint Pierre & Miquelon
    'PR', // Puerto Rico
    'SV', // El Salvador
    'SX', // Sint Maarten
    'TC', // Turks & Caicos Islands
    'TT', // Trinidad & Tobago
    'US', // United States
    'VC', // Saint Vincent & the Grenadines
    'VG', // British Virgin Islands
    'VI', // U.S. Virgin Islands
  ],

  'South America': [
    'AR', // Argentina
    'BO', // Bolivia
    'BR', // Brazil
    'CL', // Chile
    'CO', // Colombia
    'EC', // Ecuador
    'FK', // Falkland Islands
    'GF', // French Guiana
    'GS', // South Georgia & South Sandwich Islands
    'GY', // Guyana
    'PE', // Peru
    'PY', // Paraguay
    'SR', // Suriname
    'UY', // Uruguay
    'VE', // Venezuela
  ],

  'Australia/Oceania': [
    'AS', // American Samoa
    'AU', // Australia
    'CC', // Cocos (Keeling) Islands
    'CK', // Cook Islands
    'CX', // Christmas Island
    'FJ', // Fiji
    'FM', // Micronesia
    'GU', // Guam
    'HM', // Heard & McDonald Islands
    'KI', // Kiribati
    'MH', // Marshall Islands
    'MP', // Northern Mariana Islands
    'NC', // New Caledonia
    'NF', // Norfolk Island
    'NR', // Nauru
    'NU', // Niue
    'NZ', // New Zealand
    'PF', // French Polynesia
    'PG', // Papua New Guinea
    'PN', // Pitcairn
    'PW', // Palau
    'SB', // Solomon Islands
    'TK', // Tokelau
    'TO', // Tonga
    'TV', // Tuvalu
    'UM', // U.S. Outlying Islands
    'VU', // Vanuatu
    'WF', // Wallis & Futuna
    'WS', // Samoa
  ],

};

const ROUTING_RULES = [
  {
    region: 'Asia',
    segment: 'interior-design',
    action: 'redirect',
    url: 'https://apac-middleeast.univicoustic.com/',
  },
  {
    region: '*',
    segment: 'pro-audio-hifi',
    action: 'stay',
  },
  {
    region: '*',
    segment: 'interior-design',
    action: 'stay',
  },
];

const STORAGE_KEY = 'vicoustic_market_preference';
const COOKIE_BANNER_SELECTOR = '#shopify-pc__banner';

// Global state used by other popups that need to respect
// the market selector's priority.
window.vicousticMarketSelector = window.vicousticMarketSelector || {
  priority: false,
};

function getRegionFromCountry(countryCode) {
  if (!countryCode) return null;

  for (const [region, countries] of Object.entries(REGION_COUNTRIES)) {
    if (countries.includes(countryCode)) {
      return region;
    }
  }

  return null;
}

function getRoutingRule(region, segment) {
  return (
    ROUTING_RULES.find(
      (rule) => rule.region === region && rule.segment === segment
    ) ||
    ROUTING_RULES.find(
      (rule) => rule.region === '*' && rule.segment === segment
    ) ||
    { action: 'stay' }
  );
}

function getStoredPreference() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (!stored) return null;

    return JSON.parse(stored);
  } catch {
    return null;
  }
}

function savePreference(region, segment) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        region,
        segment,
      })
    );
  } catch {}
}

function hideCookieBanner() {
  const banner = document.querySelector(COOKIE_BANNER_SELECTOR);

  if (!banner) return false;

  banner.dataset.marketSelectorHidden = 'true';
  banner.style.display = 'none';

  return true;
}

function restoreCookieBanner() {
  const banner = document.querySelector(COOKIE_BANNER_SELECTOR);

  if (!banner) return;

  if (banner.dataset.marketSelectorHidden !== 'true') return;

  delete banner.dataset.marketSelectorHidden;
  banner.style.display = '';
}

if (!customElements.get('market-selector-modal')) {
  customElements.define(
    'market-selector-modal',
    class MarketSelectorModal extends ModalElement {
      constructor() {
        super();

        this.cookieBannerObserver = null;
      }

      get shouldLock() {
        return true;
      }

      get shouldCloseAll() {
        return true;
      }

      connectedCallback() {
        super.connectedCallback();

        this.regionSelect = this.querySelector('#MarketSelectorRegion');
        this.segmentRadios = this.querySelectorAll('input[name="Segment"]');
        this.continueButton = this.querySelector('#MarketSelectorContinue');

        this.country = this.dataset.country;
        this.region = getRegionFromCountry(this.country);

        this.initialiseRegion();
        this.initialiseForm();
        this.initialiseVisibility();
        }

      initialiseRegion() {
        if (!this.regionSelect) return;

        this.regionSelect.value = this.region || '';
      }
      
      getSelectedSegment() {
        return this.querySelector('input[name="Segment"]:checked')?.value || '';
        }

      initialiseForm() {
        if (
            !this.regionSelect ||
            !this.segmentRadios.length ||
            !this.continueButton
        ) {
            return;
        }

        this.regionSelect.addEventListener('change', () => {
            this.updateContinueButton();
        });

        this.segmentRadios.forEach((radio) => {
            radio.addEventListener('change', () => {
            this.updateContinueButton();
            });
        });

        this.continueButton.addEventListener('click', () => {
            this.handleContinue();
        });

        this.updateContinueButton();
        }

      initialiseVisibility() {
        if (Shopify.designMode) return;

        const params = new URLSearchParams(window.location.search);
        const testMode = params.get('market_popup_test') === 'true';

        if (!testMode) return;

        this.startPriorityObservers();
        this.show();
        }

      updateContinueButton() {
        if (!this.continueButton) return;

        const regionSelected = !!this.regionSelect?.value;
        const segmentSelected = !!this.getSelectedSegment();

        this.continueButton.disabled = !(
            regionSelected &&
            segmentSelected
        );
        }

      handleContinue() {
        const region = this.regionSelect?.value;
        const segment = this.getSelectedSegment();

        if (!region || !segment) return;

        const rule = getRoutingRule(region, segment);

        // Redirect choices are never stored.
        if (rule.action === 'redirect' && rule.url) {
            window.location.href = rule.url;
            return;
        }

        // Stay choices are stored.
        savePreference(region, segment);
        this.hide();
        }

      startPriorityObservers() {
        // Give the market selector priority over the newsletter popup.
        window.vicousticMarketSelector.priority = true;

        if (this.cookieBannerObserver) return;

        // Handle a cookie banner that already exists.
        hideCookieBanner();

        // Keep the cookie banner hidden while the market selector is open.
        this.cookieBannerObserver = new MutationObserver(() => {
          hideCookieBanner();
        });

        this.cookieBannerObserver.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }

      stopPriorityObservers() {
        this.cookieBannerObserver?.disconnect();
        this.cookieBannerObserver = null;

        // Allow the newsletter popup to operate normally again.
        window.vicousticMarketSelector.priority = false;
      }

      afterShow() {
        super.afterShow();

        this.updateContinueButton();
      }

      afterHide() {
        super.afterHide();

        this.stopPriorityObservers();
        restoreCookieBanner();
      }
    }
  );
}